import { ReactElement } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import LogInPage from './views';

const LoginRoute = (props:any): ReactElement => (
  <LogInPage logoData={props.logoData}/>
);

export default LoginRoute;
